export const HOME_PAGE_METATAG_CONTENT =
  "The CERN Academic Training lectures cover physics and technology research results, as well as leading-edge news from other disciplines. Past lectures often present a great historical value.";
